import React from 'react'
import {TextField, TextFieldProps} from '@material-ui/core'
import styles from './styles'

export type TextInputProps = {
  onChangeText: (text: string) => void
  onSubmitEditing?: () => void
} & TextFieldProps

const onKeyDown = (key: string, {onSubmitEditing}: TextInputProps) => {
  if (key === 'Enter' && onSubmitEditing) {
    onSubmitEditing()
  }
}

const TextInput = ({style, ...props}: TextInputProps) => (
  <TextField
    {...props}
    variant="outlined"
    style={{...styles.input, ...(style as any)}}
    onKeyDown={(e) => onKeyDown(e.key, props)}
    onChange={(e) => props.onChangeText(e.target.value)}
  />
)

export default TextInput
